import { STALE_TIME_RESOURCES } from "@impero-com/common/utils/query_client";

import { useGetFinancialYear } from "api/generated/financial-years/financial-years";

import { CONTROL_LIST_QUERY_OPTIONS } from "./controlListQueryOptions";

export function useOrgFinancialYearQuery() {
    return useGetFinancialYear({
        query: {
            ...CONTROL_LIST_QUERY_OPTIONS,
            select: (response) => response.data,
            staleTime: STALE_TIME_RESOURCES,
        },
    });
}
